export const mockActivityData = [
    {
        activity: "Climbing",
        _id: "865894hnfuvai9"
    },
    {
        activity: "Running",
        _id: "865vnkrvmhnfuvai9"
    },
    {
        activity: "Football",
        _id: "865894hn84858vai9"
    },
    {
        activity: "Golf",
        _id: "8nvkf894hnfuvai9"
    },
    {
        activity: "Swimming",
        _id: "8jgjgjnkrvmhnfuvai9"
    },
    {
        activity: "Yoga",
        _id: "865894hn8lok8vai9"
    },
    {
        activity: "Basketball",
        _id: "8jgpolnkrvmhnfuvai9"
    },
    {
        activity: "Dancing",
        _id: "8658596hn8lok8vai9"
    },
]